import { supabase } from "@/integrations/supabase/client";

// Default ElevenLabs voice IDs per brand tone
export const DEFAULT_ELEVENLABS_VOICE_ID = "9BWtsMINqrJLrRacOk9x"; // Aria

export async function speakWithElevenLabs(text: string, voiceId: string = DEFAULT_ELEVENLABS_VOICE_ID) {
  if (!text?.trim()) return;

  const { data, error } = await supabase.functions.invoke("elevenlabs-tts", {
    body: { text, voiceId },
  });

  if (error) throw new Error(error.message);
  if (!data?.audioContent) throw new Error("No audio returned");

  const audioSrc = `data:${data.mimeType || "audio/mpeg"};base64,${data.audioContent}`;

  const audio = new Audio(audioSrc);
  // Slightly lower volume for ambient experience
  audio.volume = 0.9;
  await audio.play();
}
